
import axios from 'config/axiosConfig'

import { statuses } from 'keys';
import { reading_assessment, admin_assessments, assessments } from 'keys/apis';

export const startAudioCuttingFetch = async ({ id, isTrainingAssessment }) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/start_audio_cutting/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/start_audio_cutting/`

    return await axios.post(url)
}

export const audioCuttingSaveDraftFetch = ({ id, isTrainingAssessment }) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/audio_cutting_save_draft/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/audio_cutting_save_draft/`
    return axios.post(url)
}

export const audioCuttingCompleteFetch = async ({ id }) => {
    return await axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/audio_cutting_complete/`)
}



export const startMarkingWordsFetch = async ({ assessment, isTrainingAssessment }) => {
    const { id } = assessment

    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/start_marking_words/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/start_marking_words/`

    return await axios.post(url)
}

export const continueMarkingWordsFetch = ({ assessment, isTrainingAssessment }) => {
    const { id } = assessment

    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/continue_marking_words/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/continue_marking_words/`

    if (id)
        return axios.post(url)
}

export const backToMarkingWordsFetch = async ({ assessment, isTrainingAssessment }) => {
    const { id } = assessment

    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/back_to_marking_words/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/back_to_marking_words/`

    if (id)
        return await axios.post(url)
}

export const backToAudioCuttingFetch = async (assessment) => {
    const { id } = assessment

    if (id)
        return await axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/back_to_audio_cutting/`)
}

export const backToTranscriptionFetch = async (assessment) => {
    const { id } = assessment

    if (id)
        return await axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/back_to_transcription/`)
}

export const markingWordsSaveDraftFetch = ({ id, data, isTrainingAssessment }) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/marking_words_save_draft/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/marking_words_save_draft/`
    return axios.post(url, {
        ...data
    })
}

export const markingWordsCompleteFetch = async ({ id, data, isTrainingAssessment }) => {
    let url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/marking_words_complete/`
    if (isTrainingAssessment)
        url = `${process.env.REACT_APP_SERVER_PORT}${reading_assessment}training_admin_assessments/${id}/marking_words_complete/`
    return await axios.post(url, {
        ...data
    })
}

export const updateRedoStatusFetch = async (id) => {
    return await axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${assessments}${id}/update_status/`, {
        status: statuses.redo,
        sub_status: null
    })
}

export const transcriptionSaveDraftFetch = ({ id, data }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/transcription_save_draft/`, {
        ...data
    })
}

export const transcriptionCompleteFetch = async ({ id, data }) => {
    return await axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/transcription_complete/`, {
        ...data
    })
}

export const startTranscriptionFetch = async (assessment) => {
    const { id } = assessment

    return await axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/start_transcription/`)
}

export const continueTranscriptionFetch = (assessment) => {
    const { id } = assessment

    if (id)
        return axios.post(`${process.env.REACT_APP_SERVER_PORT}${reading_assessment}${admin_assessments}${id}/continue_transcription/`)
}




